<<template>
  <div>
    <select class="float-right form-control-sm tw--mt-1"
            title="Select a variable that will be replaced by the real value."
            data-toggle="tooltip" @change="addVariable()" v-model="variable">
        <option value="" selected disabled>Add a variable</option>
        <option value="contact_name">Contact Name</option>
        <option value="company_name">Company Name</option>
        <option value="location_name">Location Name</option>
    </select>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    message: {
      required: true
    }
  },

  data() {
    return  {
      message_content: _.clone(this.message),
      variable: ''
    }
  },

  watch: {
    message: {
      handler(message){
        this.message_content = message;
      }
    }
  },

  methods: {
    addVariable() {
        this.message_content = (this.message_content ? this.message_content : '') + `{{${this.variable}}}`;
        this.variable  = '';
        this.$emit('messageUpdated', this.message_content);
    }
  }
}
</script>

<style>

</style>
